import {Link} from 'react-router-dom'

export function Registration() {
  return (
    <div className='text-center'>
      <h1 className='text-dark fw-bolder mb-3'>Registration Unavailable</h1>
      <p className='text-gray-500 fw-semibold fs-6 mb-8'>
        Admin accounts are provisioned internally.<br />
        Please contact your system administrator.
      </p>
      <Link to='/auth/login' className='btn btn-primary'>
        Back to Sign In
      </Link>
    </div>
  )
}
